import { HopperIcon, type HopperIconName } from '../ui/icons/HopperIcon';

type PulseMobileNavProps = {
  active: 'pulse' | 'routes';
  onOpenPulse: () => void;
  onOpenRoutes: () => void;
};

type NavItem = {
  key: 'pulse' | 'map' | 'offers' | 'routes' | 'profile';
  label: string;
  icon: HopperIconName;
  legacyLabel?: string;
  onClick?: () => void;
};

function clickLegacyNav(label: string): void {
  const buttons = Array.from(document.querySelectorAll<HTMLButtonElement>('.mobile-bottom-nav .mobile-nav-item'));
  const target = buttons.find((button) => button.textContent?.trim() === label);
  target?.click();
}

export function PulseMobileNav({ active, onOpenPulse, onOpenRoutes }: PulseMobileNavProps) {
  const items: NavItem[] = [
    { key: 'pulse', label: 'Пульс города', icon: 'home', onClick: onOpenPulse },
    { key: 'map', label: 'Карта', icon: 'map', legacyLabel: 'Карта' },
    { key: 'offers', label: 'Предложения', icon: 'offers', legacyLabel: 'Предложения' },
    { key: 'routes', label: 'Маршруты', icon: 'routes', onClick: onOpenRoutes },
    { key: 'profile', label: 'Профиль', icon: 'profile', legacyLabel: 'Профиль' },
  ];

  return (
    <nav className="pulse-mobile-nav" aria-label="Основная навигация">
      {items.map((item) => {
        const isActive = item.key === active;
        const legacyLabel = item.legacyLabel;
        const handleClick = item.onClick ?? (legacyLabel ? () => clickLegacyNav(legacyLabel) : undefined);
        return (
          <button
            type="button"
            key={item.key}
            className={isActive ? 'pulse-mobile-nav__item is-active' : 'pulse-mobile-nav__item'}
            aria-current={isActive ? 'page' : undefined}
            onClick={handleClick}
          >
            <HopperIcon name={item.icon} size={22} />
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
